import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../../footer.js";
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";

const Widgets = () => {
  const [formData, setFormData] = useState({
    websiteUrl: "",
    styles: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Add functionality to handle the form submission
  };

  return (
    <>
      <Header />
      <Navvbar/>
      <br />
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-2" style={{ borderRight: "2px solid #004aad" }}>
            <h3>Promotions</h3>
            <div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/website">DDX Websites</Link>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/ddxAdd">DDX Ads</Link>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/coupon">DDX Coupons</Link>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/widgets">Widgets</Link>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/action">Links</Link>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Link to="/ddxAccount">DDX Account Onboarding</Link>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-10">
            <div style={{ margin: "20px", fontFamily: "Arial, sans-serif" }}>
              <h2 style={{ color: "#004aad", borderBottom: "2px solid #004aad" }}>DDX Website Widgets</h2>
                      <p>
                DDX web widgets are stand-alone applications that can be embedded
                into your website. With a DDX web widget, your website users can
                submit a DDX case without leaving your website.
              </p>
              
              <form
                onSubmit={handleSubmit}
                style={{
                  backgroundColor: "#f3f3f3",
                  padding: "20px",
                  borderRadius: "5px",
                }}
              >
                <h4 style={{ color: "#004aad", marginBottom: "20px", borderBottom: "2px solid #004aad", backgroundColor: "white",  }}>
                  Build Your Web Widget
                </h4>
                <div style={{ marginBottom: "15px" }}>
                  <label
                    htmlFor="websiteUrl"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    Web Site URL <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="websiteUrl"
                    name="websiteUrl"
                    value={formData.websiteUrl}
                    onChange={handleChange}
                    style={{
                      width: "40%",
                      padding: "10px",
                      border: "1px solid #004aad",
                      borderRadius: "5px",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label
                    htmlFor="styles"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    Styles
                  </label>
                  <textarea
                    id="styles"
                    name="styles"
                    value={formData.styles}
                    onChange={handleChange}
                    style={{
                      width: "40%",
                      padding: "10px",
                      border: "1px solid #004aad",
                      borderRadius: "5px",
                      minHeight: "100px",
                    }}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#004aad",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  + Add
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <Footer />
            </div>
    </>
  );
};

export default Widgets;
